<ng-container *ngIf="!isACPayment">
    <!-- ========== Dialog Title ========= -->
    <ng-container *ngIf="!is_select_option">
        <div class="mat-main">
            <div class="mat-header">
                <h2 mat-dialog-title style="margin-bottom: 0px">{{"TITLE.SELECT_PAYMENT" | translate}}</h2>
                <button mat-dialog-close="true" class="btn btn-close">
                  <mat-icon>close</mat-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
        </div>
    </ng-container>
    <!-- ========== End Title========= -->

    <ng-container *ngIf="is_select_option">
        <div class="mat-main">
            <div class="mat-header option-type">
                <button (click)="handleClose()" class="btn btn-close">
                <mat-icon svgIcon="arrow-back" class="arrow-back"></mat-icon>
            </button>
                <h2 mat-dialog-title style="margin-bottom: 0px">
                    {{ "BANKS.SELECT_BANKS" | translate }}
                </h2>
            </div>
            <mat-divider></mat-divider>
        </div>
    </ng-container>
    <!-- ========== End Title========= -->

    <!-- *====== Dialog Content ======* -->
    <mat-dialog-content>
        <!--========== path-1 ========== -->
        <ng-container *ngIf="!is_select_option">
            <ng-container *ngFor="let payment of payments; let index= index">
                <mat-card class="card" [class.card-bottom]="index + 1 < payments?.length" (click)="selectPayment(payment, false)">
                    <div class="card-content">
                        <img class="main-img" [src]="'assets/img/banks/' + (payment?.method_type === 'CARD' ?  payment?.method_type.toLowerCase() : payment?.code.toLowerCase() + '_' + payment?.method_type.toLowerCase()) + '.png'" alt="{{ image }}" />
                        <div class="card-type">
                            <span class="card-title">{{ payment.title }}</span>
                            <ng-container *ngIf="payment.code !== 'CARD'">
                                <span class="description">{{getDescription(payment)}}</span>
                            </ng-container>

                            <div *ngIf="payment.code === 'CARD'" class="group-icons">
                                <ng-container *ngFor="let image of images">
                                    <img [src]="'/assets/img/banks/' + image + '.png'" alt="{{ image }}" class="group-icon" />
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <mat-icon svgIcon="next_arrow"></mat-icon>
                </mat-card>
            </ng-container>
        </ng-container>
        <!--=========== end-1 =========== -->

        <!--=========== path-2 =========== -->
        <ng-container *ngIf="is_select_option">
            <div class="animated-local-bankpay ">
                <ng-container *ngFor="let payment of paymentOption; let index= index">
                    <mat-card class="child-card card-bottom" (click)="selectPayment(payment, true)">
                        <div class="card-content">
                            <div class="card-type">
                                <span class="card-title">{{ payment?.name === 'ACLEDA' ? "Diners Club" : "VISA, Mastercard, UnionPay, JCB"}}</span>
                                <div *ngIf="select_payment === 'CARD'; else otherOption" class="group-icons">
                                    <ng-container *ngFor="let image of getImages(payment?.code.toLowerCase())">
                                        <img [src]="'/assets/img/banks/' + image + '.png'" alt="{{ image }}" class="group-icon" />
                                    </ng-container>
                                </div>
                            </div>

                            <ng-template #otherOption>
                                <span class="description">{{getDescription(bank)}}</span>
                            </ng-template>
                        </div>
                        <mat-icon svgIcon="next_arrow"></mat-icon>
                    </mat-card>
                </ng-container>
            </div>
        </ng-container>
        <!--============== end-2 ============== -->
    </mat-dialog-content>
    <!-- *============== End Content ===============* -->
</ng-container>

<!-- =============== Show Iframe ================ -->
<div *ngIf="isACPayment " id="iframe-wrapper " style="position: relative; display: unset; ">
    <iframe #iframeKhqrBakong [srcdoc]="htmlString " [ngClass]="codeStyle.toLowerCase() "></iframe>
</div>
